import _ from 'lodash';
import customFilterColumnsExtend from '../custom_filter_columns_extend';
import { columnsExtend as entityColumnsExtend, formColumnsExtend as entityFormColumnsExtend } from '../admin_entities/payment_account_detail.js';
import { shareColumnsExtend } from './share';
export const filterColumns = {
  name_cont: {
    model_name: 'PaymentAccount',
    column_type: 'string',
    column_name: 'name',
  },
  code_cont: {
    model_name: 'PaymentAccount',
    column_type: 'string',
    column_name: 'code',
  },
  state_eq: {
    column_type: 'enum',
    extra: {
      model_name: 'PaymentAccount',
      options: ['active', 'inactive'],
    },
    model_name: 'PaymentAccount',
    column_name: 'state',
  },
}
export const formColumnsConfig = {
  'self': {
    'code': { required: true, disabledUpdate: false },
    'name': { required: true, disabledUpdate: false },
    'tax_rate': { required: true, disabledUpdate: false },
    'position': { required: false, disabledUpdate: false },
    'remark': { required: false, disabledUpdate: false },
  },
}

export const filterColumnsExtend = (columns) => {
  const customColumns = customFilterColumnsExtend(filterColumns)

  return columns.map(hash => {
    if (typeof hash === 'string') {
      return customColumns[hash]
    } else if (hash['key']) {
      return _.merge(customColumns[hash['key']], hash)
    } else {
      return hash
    }
  })
}

export const columnsExtend = (columns) => {
  return entityColumnsExtend(shareColumnsExtend('PaymentAccount', columns))
}

export const formColumnsExtend = (columns, { data, type }) => {
  return _.map(entityFormColumnsExtend(shareColumnsExtend('PaymentAccount', columns), { data, type, formColumnsConfig: formColumnsConfig['self'] }))
}
